import React from "react";

const NotesList=(props)=>(
    <ul>
        {props.children}
    </ul>
)
export default NotesList